import Vue from 'vue';
import Plyr from 'plyr';
import VueLazyDirective from '../directives/v-lazy';

import EventBus from '../vue/bus';

import CtaButton from '../vue/CtaButton.vue';
import VideoPlayButton from '../vue/VideoPlayButton.vue';
import HeroModalVideo from '../vue/HeroModalVideo.vue';

export default function(el) {
  if (el === null) return false;
  new Vue({
    el,
    delimiters: ['${', '}'],
    directives: {
      lazy: VueLazyDirective,
    },
    components: {
      CtaButton,
      VideoPlayButton,
      HeroModalVideo,
    },
    props: {
      items: {
        type: Array,
        default() {
          return JSON.parse(el.dataset.items);
        },
      },
    },
    data() {
      return {
        ready: false,
        currentItem: 1,
        heroPlyr: null,
        currentKey: 1,
        interval: null,
        playing: true,
        reverse: true,
      };
    },
    computed: {
      totalItems() {
        return this.items.length;
      },
      isFirstItem() {
        return this.currentItem === 1;
      },
      isLastItem() {
        return this.currentItem === this.totalItems;
      },
      nextItem() {
        if (!this.isLastItem) {
          return this.currentItem + 1;
        } else {
          return 1;
        }
      },
      previousItem() {
        if (!this.isFirstItem) {
          return this.currentItem - 1;
        } else {
          return this.totalItems;
        }
      },
      currentItemData() {
        return this.items[this.currentItem - 1];
      },
    },
    mounted() {
      if (this.currentItemData.hasVideo === true) {
        this.initVideo();
      }

      this.ready = true;

      this.cleanUpData();
      this.interval = setInterval(() => {
        this.currentItem = this.nextItem;

        if (this.currentItemData.hasVideo === true) {
          this.$nextTick(() => {
            this.ready = false;
            this.initVideo();
          });
        }
      }, 8000);
    },
    methods: {
      initVideo() {
        this.heroPlyr = this.$refs.heroVideo.map(videoRef => {
          return new Plyr(videoRef, {
            controls: [],
            settings: [],
            autoplay: true,
            autopause: false,
            muted: true,
            loop: {
              active: true,
            },
            fullscreen: {
              enabled: false,
            },
            storage: {
              enabled: false,
            },
          });
        });

        this.ready = true;
      },
      cleanUpData() {
        Object.keys(this.$el.dataset).forEach(dataKey => {
          delete this.$el.dataset[dataKey];
        });
      },
      handleSwiperButtonClick(direction) {
        if (direction === 'next') {
          this.reverse = true;
          this.currentItem = this.nextItem;
        } else if (direction === 'previous') {
          this.reverse = false;
          this.currentItem = this.previousItem;
        }

        clearInterval(this.interval);
        this.interval = null;
        this.playing = false;

        this.$nextTick(() => {
          this.ready = false;
          this.heroPlyr = null;
          this.initVideo();
        });
      },
      videoClickHandler() {
        clearInterval(this.interval);
        this.interval = null;
        this.playing = false;
        EventBus.$emit(EventBus.HERO_VIDEO_CLICK);
      },
      carouselHandler() {
        if (!this.interval) {
          this.interval = setInterval(() => {
            this.currentItem = this.nextItem;

            this.$nextTick(() => {
              this.ready = false;
              this.heroPlyr = null;
              this.initVideo();
            });
          }, 8000);
          this.playing = true;
        } else {
          clearInterval(this.interval);
          this.interval = null;
          this.playing = false;
        }
      },
    },
  });
}
